<agpr-dialog-container
    [id]="id"
    class="tveyes-archive-dialogContainer"
    [heading]="mention?.headline ?? 'Loading Mention'"
    (close)="close()"
    [contentPadding]="false"
>
    <div class="tveyes-archive-content">
        <div class="tveyes-archive-content-header">
            <div class="tveyes-archive-media">
                @if (mention?.mediaType.id === mediaTypeEnum.RADIO) {
                    <div class="tveyes-archive-media-radio">
                        <span class="fa-regular fa-duotone fa-tower-cell"></span>
                    </div>
                    <iframe
                        allowfullscreen
                        class="tveyes-archive-media-radio-iframe"
                        [src]="iFrameURL | agprBypassURLSecurity"
                        frameborder="0"
                    ></iframe>
                } @else {
                    <div class="tveyes-archive-media-broadcast-container">
                        <iframe
                            allowfullscreen
                            class="tveyes-archive-media-broadcast-iframe"
                            [src]="iFrameURL | agprBypassURLSecurity"
                            frameborder="0"
                        ></iframe>
                    </div>
                }
            </div>
            <div class="tveyes-archive-info">
                @for (attribute of attributes; track attribute.id) {
                    <agpr-meta-data
                        [id]="id"
                        [type]="attribute.type"
                        [mediaType]="attribute.mediaType"
                        [icon]="attribute.icon"
                        [value]="attribute.value"
                        [isSimilarWeb]="attribute.isSimilarWeb"
                        [tooltip]="attribute.label"
                        tooltipPosition="right"
                        [infoTooltip]="attribute.infoTooltip"
                        [isMultiline]="attribute.isMultiline"
                        [showCopyIcon]="!!attribute?.showCopyIcon && !!attribute?.copyValue"
                        [copyValue]="attribute?.copyValue"
                        [copyToolTip]="attribute?.copyToolTip"
                    ></agpr-meta-data>
                }
            </div>
        </div>
        <div class="tveyes-archive-transcript">
            <agpr-scroll-panel class="tveyes-archive-scrollPanel">
                <div
                    class="tveyes-archive-transcript-body"
                    [innerHTML]="mention?.body | highlightKeywords:highlightKeywords"
                ></div>
            </agpr-scroll-panel>
        </div>
    </div>

    <ng-template #footerLeft>
        <agpr-button
            [id]="id + 'closeBtn'"
            label="close"
            (click)="close()"
            [style]="buttonTypesEnum.secondary"
        ></agpr-button>
    </ng-template>
</agpr-dialog-container>
